import Loader from '../Layout/Loader';
import { withLoading } from '@front-activerse/common-components';

const FeedbackContainer = ({ feedback }) => {
  if (feedback?.url) {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('redirect');

    if (redirectUrl) {
      const feedbackUrl = new URL(feedback.url);
      const ssoToken = feedbackUrl.searchParams.get('ssoToken');
      const finalRedirectUrl = `${redirectUrl}${
        redirectUrl.includes('?') ? '&' : '?'
      }ssoToken=${ssoToken}`;
      window.location.replace(finalRedirectUrl);
    } else {
      window.location.replace(feedback.url);
    }
  } else {
    throw new Error('Feedback url not found');
  }
};

export default withLoading(FeedbackContainer, Loader);
